import { AssociatedProperty, IAssociatedProperty } from '@app/models/AssociatedProperty'
import { actionCreators, IGlobalPropertiesState } from '@app/store/modules/global'
import { bindFunctions } from '@app/utils/class'
import { List } from 'immutable'
import * as React from 'react'
import Select, { MultiValue } from 'react-select'

interface IAssociatedPropertiesSelectorProps {
  name?: string
  onChange: (newValue: List<AssociatedProperty>) => void
  placeholder?: string
  required?: boolean
  value: List<IAssociatedProperty>
}

interface IAssociatedPropertiesSelectorState {
  input: string
}

type AssociatedPropertiesSelectorProps = IAssociatedPropertiesSelectorProps &
  IGlobalPropertiesState &
  typeof actionCreators

export class AssociatedPropertiesSelector extends React.PureComponent<
  AssociatedPropertiesSelectorProps,
  IAssociatedPropertiesSelectorState
> {
  private selectRef: React.RefObject<HTMLDivElement>

  constructor(props: AssociatedPropertiesSelectorProps) {
    super(props)

    this.state = {
      input: '',
    }

    this.selectRef = React.createRef()
    bindFunctions(this)
  }

  public componentDidMount() {
    this.props.getPropertiesList()
    this._checkValidity()
  }

  public componentDidUpdate() {
    this._checkValidity()
  }

  public render() {
    return (
      <div ref={this.selectRef}>
        <Select
          inputValue={this.state.input}
          onInputChange={(e) => this.setState({ input: e })}
          isMulti
          onChange={this._onChange}
          formatOptionLabel={(data) => (
            <div>
              <div>
                <div>{data.name}</div>
              </div>
              <div>
                <div className="text-muted" style={{ fontSize: '0.875rem' }}>
                  {data.address.line1 ? data.address.line1 : null}
                </div>
              </div>
            </div>
          )}
          options={this.props.properties.results.toArray()}
          placeholder={this.props.placeholder || 'Add properties...'}
          required={this.props.required}
          value={this.props.value.toArray()}
          filterOption={(option, rawInput) => {
            const input = rawInput.toLowerCase()
            const data = option.data as IAssociatedProperty

            const matches =
              data.name.toLowerCase().includes(input) ||
              (data.address.line1 && data.address.line1.toLowerCase().includes(input)) ||
              (data.address.line2 && data.address.line2.toLowerCase().includes(input)) ||
              (data.address.city && data.address.city.toLowerCase().includes(input)) ||
              (data.address.state && data.address.state.toLowerCase().includes(input))

            return matches ? true : false
          }}
          getOptionValue={(opt) => opt.propertyId}
          getOptionLabel={(opt) => opt.name}
        />
      </div>
    )
  }

  private _checkValidity() {
    if (this.selectRef.current) {
      const inputElem = this.selectRef.current.querySelector('input:invalid')
      if (inputElem) {
        this.selectRef.current.classList.add('invalid')
      } else {
        this.selectRef.current.classList.remove('invalid')
      }
    }
  }

  private _onChange(newValue: MultiValue<IAssociatedProperty>) {
    this.props.onChange(List(newValue ?? []))
  }
}
